export const models = [
  {
    id: "1",
    name: "BERT Large Uncased",
    HuggingFace_Link: "bert-large-uncased-whole-word-masking-finetuned-squad",
    available: false,
    type: "QA",
    api_endpoint: "bert-large",
  },
  {
    id: "2",
    name: "BERT Large Cased",
    HuggingFace_Link: "bert-large-cased-whole-word-masking-finetuned-squad",
    available: false,
    type: "QA",
    api_endpoint: "bert-large",
  },
  {
    id: "3",
    name: "BERT Base Uncased",
    HuggingFace_Link: "AnonymousSub/bert-base-uncased_squad2.0",
    available: false,
    type: "QA",
    api_endpoint: "bert-large",
  },
  {
    id: "4",
    name: "BERT Base Cased",
    HuggingFace_Link: "deepset/bert-base-cased-squad2",
    available: false,
    type: "QA",
    api_endpoint: "bert-large",
  },
  {
    id: "5",
    name: "Falcon 7B",
    HuggingFace_Link: "tiiuae/falcon-7b",
    available: false,
    type: "TEXT_GEN",
    api_endpoint: "falcon",
  },
  {
    id: "5",
    name: "Falcon 7B Instruct",
    HuggingFace_Link: "tiiuae/falcon-7b",
    available: false,
    type: "TEXT_GEN",
    api_endpoint: "falcon",
  },
];
